import { MoreVertical, RefreshCw, UserMinus } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu.tsx';
import useRecalculateClientBalance from '@/features/dashboard/balances/hooks/useRecalculateClientBalance.ts';
import { WITHDRAWAL_TITLE } from '@/features/dashboard/bookingChanges/components/withdrawal/withdrawalCopy.ts';

interface BookingActionsMenuProps {
  /** Zapisujący rezerwacji — klient i rezerwacja są 1:1, więc jego saldo jest saldem rezerwacji. */
  clientId: string;
  /** Otwiera okno rezygnacji; brak = pozycji nie pokazujemy (ekran zapisującego). */
  onOpenWithdrawal?: () => void;
}

/**
 * Menu akcji rezerwacji w nagłówku ekranów rezerwacji, uczestnika
 * i zapisującego: przeliczenie salda i — poza zapisującym — rezygnacja.
 *
 * Rezygnacja z ekranu rezerwacji i z ekranu uczestnika prowadzi do tego
 * samego okna; różni je tylko osoba zaznaczona z góry.
 */
const BookingActionsMenu = ({
  clientId,
  onOpenWithdrawal,
}: BookingActionsMenuProps) => {
  const recalculate = useRecalculateClientBalance(clientId);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <ActionButton
          tone="outline"
          size="sm"
          iconOnly
          aria-label="Więcej akcji rezerwacji"
        >
          <MoreVertical />
        </ActionButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          disabled={recalculate.isPending}
          onClick={() => recalculate.mutate()}
        >
          <RefreshCw
            aria-hidden
            className={recalculate.isPending ? 'animate-spin' : undefined}
          />
          Przelicz saldo
        </DropdownMenuItem>
        {onOpenWithdrawal && (
          <DropdownMenuItem onClick={onOpenWithdrawal}>
            <UserMinus aria-hidden />
            {WITHDRAWAL_TITLE}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default BookingActionsMenu;
